import React, { useState } from 'react';
import './kurv.css';
import { Link } from 'react-router-dom';
import { useCart } from '../../CartContext/CartContext';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const Kurv = () => {
  const { cart, updateQuantity, removeFromCart, clearCart, getCartTotal } = useCart();
  const [customerInfo, setCustomerInfo] = useState({
    navn: '',
    email: '',
    telefon: '',
    adresse: '',
    postnummer: '',
    by: '',
    cvr: '',
    ean: '',
    besked: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderSent, setOrderSent] = useState(false);

  const handleQuantityChange = (productId, newQuantity) => {
    if (newQuantity === 0) {
      removeFromCart(productId);
    } else {
      updateQuantity(productId, newQuantity);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const formatPrice = (priceString) => {
    const price = parseFloat(priceString.replace(/[^\d,]/g, '').replace(',', '.')) || 0;
    return price.toLocaleString('da-DK', {
      style: 'currency',
      currency: 'DKK'
    });
  };

  const generateOrderEmailHTML = () => {
    const orderItems = cart.items.map(item => 
      `<tr>
        <td style="padding: 8px; border-bottom: 1px solid #ddd;">${item.quantity} x ${item.navn}</td>
        <td style="padding: 8px; border-bottom: 1px solid #ddd; text-align: right;">${item.pris}</td>
      </tr>`
    ).join('');
    
    const total = getCartTotal();
    const totalFormatted = total.toLocaleString('da-DK', {
      style: 'currency',
      currency: 'DKK'
    });

    const emailHTML = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <h2 style="color: #2c3e50; border-bottom: 2px solid #8aa5ae; padding-bottom: 10px;">
        Ny bestilling fra Psykologisk Perspektiv Shop
      </h2>
      
      <div style="background-color: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0;">
        <h3 style="color: #2c3e50; margin-top: 0;">Kundeoplysninger</h3>
        <table style="width: 100%; border-collapse: collapse;">
          <tr><td style="padding: 5px 0; font-weight: bold;">Navn:</td><td>${customerInfo.navn}</td></tr>
          <tr><td style="padding: 5px 0; font-weight: bold;">Email:</td><td>${customerInfo.email}</td></tr>
          <tr><td style="padding: 5px 0; font-weight: bold;">Telefon:</td><td>${customerInfo.telefon || 'Ikke angivet'}</td></tr>
          <tr><td style="padding: 5px 0; font-weight: bold;">Adresse:</td><td>${customerInfo.adresse}</td></tr>
          <tr><td style="padding: 5px 0; font-weight: bold;">Postnummer:</td><td>${customerInfo.postnummer}</td></tr>
          <tr><td style="padding: 5px 0; font-weight: bold;">By:</td><td>${customerInfo.by}</td></tr>
          ${customerInfo.cvr ? `<tr><td style="padding: 5px 0; font-weight: bold;">CVR nr:</td><td>${customerInfo.cvr}</td></tr>` : ''}
          ${customerInfo.ean ? `<tr><td style="padding: 5px 0; font-weight: bold;">EAN nr:</td><td>${customerInfo.ean}</td></tr>` : ''}
        </table>
      </div>
      
      <div style="margin: 20px 0;">
        <h3 style="color: #2c3e50;">Bestilling</h3>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background-color: #8aa5ae; color: white;">
              <th style="padding: 12px; text-align: left;">Produkt</th>
              <th style="padding: 12px; text-align: right;">Pris</th>
            </tr>
          </thead>
          <tbody>
            ${orderItems}
            <tr style="background-color: #f8f9fa; font-weight: bold;">
              <td style="padding: 12px; border-top: 2px solid #8aa5ae;">TOTAL</td>
              <td style="padding: 12px; text-align: right; border-top: 2px solid #8aa5ae;">${totalFormatted}</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      ${customerInfo.besked ? `
      <div style="background-color: #fff3cd; padding: 15px; border-radius: 8px; border-left: 4px solid #ffc107;">
        <h4 style="color: #856404; margin-top: 0;">Besked fra kunde:</h4>
        <p style="color: #856404; margin-bottom: 0;">${customerInfo.besked}</p>
      </div>
      ` : ''}
      
      <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #ddd; color: #666; font-size: 14px;">
        <p>Denne bestilling er automatisk genereret fra Psykologisk Perspektiv's webshop.</p>
        <p>Dato: ${new Date().toLocaleDateString('da-DK')} kl. ${new Date().toLocaleTimeString('da-DK')}</p>
      </div>
    </div>
    `;

    return emailHTML;
  };

  const handleSubmitOrder = async () => {
    if (!customerInfo.navn || !customerInfo.email || !customerInfo.adresse) {
      alert('Udfyld venligst alle obligatoriske felter (navn, email og adresse)'); 
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Generer email-indhold
      const emailHTML = generateOrderEmailHTML();
      const subject = `Ny bestilling fra ${customerInfo.navn} - Psykologisk Perspektiv Shop`;
      
      // Opret email dokument i Firestore for at trigge email-extension
      const emailDoc = {
        to: ['maria@psykologiskperspektiv.dk', 'susanne@psykologiskperspektiv.dk', 'Admin@psykologiskperspektiv.dk'],
        message: {
          subject: subject,
          html: emailHTML,
        },
        // Tilføj metadata for tracking
        orderData: {
          customerName: customerInfo.navn,
          customerEmail: customerInfo.email,
          orderDate: new Date().toISOString(),
          totalAmount: getCartTotal(),
          items: cart.items.map(item => ({
            name: item.navn,
            quantity: item.quantity,
            price: item.pris
          }))
        }
      };
      
      // Tilføj dokument til mail collection
      await addDoc(collection(db, 'mail'), emailDoc);
      
      // Ryd kurv og vis bekræftelse
      clearCart();
      setOrderSent(true);
      
    } catch (error) {
      console.error('Fejl ved afsendelse af bestilling:', error);
      alert('Der opstod en fejl ved afsendelse af bestillingen. Prøv venligst igen.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (orderSent) {
    return (
      <div className="shop-kurv-side">
        <div className="shop-kurv-container">
          <div className="shop-ordre-bekræftelse">
            <h1>Tak for din forespørgsel!</h1>
            <p>Din bestillingsanmodning er blevet sendt til os. Vi vender tilbage til dig vedrørende pris, levering og betaling.</p>
            <p>Vi kontakter dig på den angivne email-adresse, så snart vi har behandlet din forespørgsel.</p>
            <div className="shop-kurv-knapper">
              <Link to="/shop" className="shop-bekraeftelse-knap">
                Tilbage til shop
              </Link>
              <Link to="/" className="shop-bekraeftelse-sekundaer-knap">
                Til forsiden
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (cart.items.length === 0) {
    return (
      <div className="shop-kurv-side">
        <div className="shop-kurv-container">
          <h1>Din kurv</h1>
          <div className="shop-tom-kurv">
            <p>Din kurv er tom</p>
            <Link to="/shop" className="shop-tom-kurv-knap">
              Gå til shop
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const total = getCartTotal();

  return (
    <div className="shop-kurv-side">
      <div className="shop-kurv-container">
        <h1>Din kurv</h1>
        
        <div className="shop-kurv-indhold">
          <div className="shop-kurv-produkter">
            {cart.items.map(item => (
              <div key={item.id} className="shop-kurv-produkt">
                <div className="shop-kurv-produkt-billede">
                  <img src={item.billede} alt={item.navn} />
                </div>
                <div className="shop-kurv-produkt-info">
                  <h3>{item.navn}</h3>
                  <p className="shop-kurv-produkt-pris">{item.pris}</p>
                </div>
                <div className="shop-kurv-produkt-antal">
                  <button 
                    onClick={() => handleQuantityChange(item.id, item.quantity - 1)}
                    disabled={item.quantity <= 1}
                  >
                    -
                  </button>
                  <span>{item.quantity}</span>
                  <button 
                    onClick={() => handleQuantityChange(item.id, item.quantity + 1)}
                  >
                    +
                  </button>
                </div>
                <div className="shop-kurv-produkt-total">
                  {formatPrice(item.pris.replace(/[^\d,]/g, '').replace(',', '.') * item.quantity + ' kr.')}
                </div>
                <button 
                  className="shop-kurv-fjern-knap"
                  onClick={() => removeFromCart(item.id)}
                >
                  ×
                </button>
              </div>
            ))}
            
            <div className="shop-kurv-total">
              <div className="shop-kurv-total-linje">
                <span>I alt:</span>
                <span className="shop-kurv-total-beløb">
                  {total.toLocaleString('da-DK', {
                    style: 'currency',
                    currency: 'DKK'
                  })}
                </span>
              </div>
            </div>
          </div>
          
          <div className="shop-kurv-checkout">
            <h2>Leveringsoplysninger</h2>
            <form className="shop-checkout-form">
              <div className="shop-form-group">
                <label htmlFor="navn">Navn *</label>
                <input
                  type="text"
                  id="navn"
                  name="navn"
                  value={customerInfo.navn}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="shop-form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={customerInfo.email}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="shop-form-group">
                <label htmlFor="telefon">Telefon</label>
                <input
                  type="tel"
                  id="telefon"
                  name="telefon"
                  value={customerInfo.telefon}
                  onChange={handleInputChange}
                />
              </div>
              
              <div className="shop-form-group">
                <label htmlFor="adresse">Adresse *</label>
                <input
                  type="text"
                  id="adresse"
                  name="adresse"
                  value={customerInfo.adresse}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="shop-form-row">
                <div className="shop-form-group">
                  <label htmlFor="postnummer">Postnummer *</label>
                  <input
                    type="text"
                    id="postnummer"
                    name="postnummer"
                    value={customerInfo.postnummer}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="shop-form-group">
                  <label htmlFor="by">By *</label>
                  <input
                    type="text"
                    id="by"
                    name="by"
                    value={customerInfo.by}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              
              <div className="shop-form-row">
                <div className="shop-form-group">
                  <label htmlFor="cvr">CVR nr</label>
                  <input
                    type="text"
                    id="cvr"
                    name="cvr"
                    value={customerInfo.cvr}
                    onChange={handleInputChange}
                    placeholder="f.eks. 12345678"
                  />
                </div>
                <div className="shop-form-group">
                  <label htmlFor="ean">EAN nr</label>
                  <input
                    type="text"
                    id="ean"
                    name="ean"
                    value={customerInfo.ean}
                    onChange={handleInputChange}
                    placeholder="f.eks. 5798000000000"
                  />
                </div>
              </div>
              
              <div className="shop-form-group">
                <label htmlFor="besked">Besked til os (valgfri)</label>
                <textarea
                  id="besked"
                  name="besked"
                  value={customerInfo.besked}
                  onChange={handleInputChange}
                  rows="4"
                />
              </div>
            </form>
            
            <div className="shop-checkout-info">
              <p><strong>Betalingsmetode:</strong> Faktura</p>
              <p>Vi sender dig en faktura efter leveringen.</p>
            </div>
            
            <div className="shop-kurv-knapper">
              <button 
                className="shop-kurv-send-knap"
                onClick={handleSubmitOrder}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sender bestilling...' : 'Send bestilling'}
              </button>
              <Link to="/shop" className="shop-kurv-tilbage-knap">
                Tilbage til shop
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kurv; 